import { IconName } from '@billy/design-system'

import { SearchResultCategory } from '../types/searchResultCategory'

export const categoryToIcon: Partial<Record<SearchResultCategory, IconName>> = {
  account: 'chartNoAxesColumnIncreasing',
  bill: 'receiptText',
  contact: 'userRound',
  invoice: 'file',
  organization: 'briefcaseBusiness',
  product: 'box',
}
